import React from 'react';
import SideBar from '../../navigation/sidebar.js';
import { AppLayout } from '@amzn/awsui-components-react'; 
import SandboxTable from './table/table.js';

function Sandboxes() {
    return(
        <AppLayout
            content={<SandboxTable />}
            navigation={<SideBar activeHref="/sandboxes" />}
            navigationOpen={true}
            toolsHide={true}
        />
    );
}

export default Sandboxes;
